// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__Wfp6c {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.styles_title__Bcs4A {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #696969;
}

.styles_inputContainer__J61VU {
  margin-bottom: 30px;
  width: 100%;
}

.styles_wrapper__N-8mN {
  width: 100%;
}

.styles_formButton__So1KI {
  width: 100% !important;
}

.styles_formButton__So1KI > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_text__8STTO {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  padding: 1em 0;
}

.styles_inputError__6DAGz {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_serverError__ujjmb {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__ujjmb span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_inputStyle__AVc7m {
  width: 420px !important;
  height: 44px;
}

@media only screen and (max-width: 1024px) {
  .styles_inputStyle__AVc7m {
    width: 353px !important;
    height: 44px;
  }
  .styles_text__8STTO {
    max-width: 353px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ForgetPasswordCode/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AACA;EACE,mBAAA;EACA,WAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EACE,sBAAA;AAIF;;AAFA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAMF;;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAMF;;AAHA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAMF;;AAHA;EACE,uBAAA;EACA,YAAA;AAMF;;AAHA;EACE;IACE,uBAAA;IACA,YAAA;EAMF;EAHA;IACE,gBAAA;EAKF;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  color: #696969;\n}\n.inputContainer{\n  margin-bottom:30px;\n  width:100%;\n}\n.wrapper{\n  width:100%;\n}\n.formButton{\n  width:100% !important;\n}\n.formButton>button{\n  width:100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  padding: 1em 0;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.serverError {\n  background: #ff9315;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 1em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.inputStyle {\n  width: 420px !important;\n  height: 44px;\n}\n\n@media only screen and (max-width: 1024px) {\n  .inputStyle {\n    width: 353px !important;\n    height: 44px;\n  }\n\n  .text {\n    max-width: 353px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__Wfp6c`,
	"title": `styles_title__Bcs4A`,
	"inputContainer": `styles_inputContainer__J61VU`,
	"wrapper": `styles_wrapper__N-8mN`,
	"formButton": `styles_formButton__So1KI`,
	"text": `styles_text__8STTO`,
	"inputError": `styles_inputError__6DAGz`,
	"serverError": `styles_serverError__ujjmb`,
	"inputStyle": `styles_inputStyle__AVc7m`
};
export default ___CSS_LOADER_EXPORT___;
